import { jwtToken } from './token';
import { viteEnv } from '../viteEnv';

export interface GitLabConfig {
  gitlab_url: string;
  gitlab_pat: string;
}

interface ApiResponse {
  success: boolean;
  result: GitLabConfig;
  message: string[];
  errors: string[];
}

export const fetchGitLabConfig = async (): Promise<GitLabConfig | null> => {
  try {
    const token = jwtToken();

    const headers: HeadersInit = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    // The PAT endpoint lives on the Next.js main app (the embedder),
    // not on the CMS API backend — hence its own env var.
    const response = await fetch(`${viteEnv.VITE_MAIN_APP_URL}/api/pat`, {
      headers,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data: ApiResponse = await response.json();
    
    if (data.success && data.result) {
      return data.result;
    }
    return null;
  } catch (error) {
    console.error('Failed to fetch GitLab config:', error);
    return null;
  }
};
